import React from 'react'
import Header from '../Components/Header/Header'
import Create from '../Components/Create/Create'

function CreateCard() {
  return (
    <div>
        <Header/>
        <Create/>
    </div>
  )
}

export default CreateCard